import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as methods from "../../../constants/methods";
import * as resources from "../../../constants/resources";
import * as rccActions from "../../../actions/rccActions";

import Button from "../generic/Button";

class SpectroCalibrateButton extends Component {
    handleStartCalibrationClick = () => {
        this.props.dispatchStartCalibrateSpectroAction();
    };

    render() {
        if (
            this.props.loggedUser.canNotEdit(resources.FUNCTION_SPECTRO_CALIBRATE) ||
            !this.props.connected ||
            !this.props.spectro.isConnected ||
            !this.props.spectro.isSelected ||
            this.props.spectro.isCalibrated ||
            !this.props.spectro.validMethod(methods.METHOD_SPECTRO_START_CALIBRATE)
        ) {
            return "";
        }

        return (
            <Button
                label={<Translate value="spectroTab.calibrate" />}
                className={this.props.className ?? null}
                size={this.props.size ?? null}
                onClick={this.handleStartCalibrationClick}
                disabled={this.props.spectro.dialog !== null}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        loggedUser: store.login.loggedUser,
        connected: store.rcc.connected,
        spectro: store.spectro.spectro
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchStartCalibrateSpectroAction: () => {
            dispatch(rccActions.startCalibrateSpectro());
        }
    };
};

export default SpectroCalibrateButton = connect(mapStoreToProps, mapDispatchToProps)(SpectroCalibrateButton);
